import Vue from 'vue'
import Router from 'vue-router'
import home from './home.vue'
import item from './item.vue'
import list from './list.vue'
//import search from './search.vue'
import dashboard from './dashboard.vue'
//import controllist from './controllist.vue'
import admin from './admin.vue'
import settings from './settings.vue'
import pagenotfound from './pagenotfound.vue'
import note from './note.vue'
import notes from './notes.vue'
import advancedsearch from './advancedsearch.vue'
import plan from './plan.vue'
import aboutdatabase from './aboutdatabase.vue'
import aboutproject from './aboutproject.vue'
import video from './video.vue'
import contact from './contact.vue'
import help from './help.vue'
import not_authorized from './not_authorized.vue'
import library from './library.vue'
import visualisation3d from './visualisation3d.vue'

Vue.use(Router)

const router = new Router({
  //export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      //  redirect:'/list/1621Prague/1'
      name: 'home',
      component: home
    },
    {
      path: '/item/:itemid',
      name: 'item',
      component: item
    },
    {
      path: '/list',
      name: 'list',
      component: list
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: dashboard,
      meta: { requieresAuth: true }
    },
    /* {
       path: '/search',
       name: 'search',
       component: search,
       meta: { requieresAuth: true }
     },*/
    /* {
       path: '/control-list',
       name: 'control-list',
       component: controllist
     },*/
    {
      path: '/langenfels',
      name: 'Langenfels',
      component: admin,
      meta: { requieresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: settings,
      meta: { requieresAuth: true }
    },
    {
      path: '/note/:noteid',
      name: 'note',
      component: note,
      meta: { requieresAuth: true }
    },
    {
      path: '/notes',
      name: 'notes',
      component: notes,
      meta: { requieresAuth: true }
    },
    {
      path: '/advancedsearch',
      name: 'advancedsearch',
      component: advancedsearch,
      meta: { requieresAuth: true }
    },
    {
      path: '/plan',
      name: 'plan',
      component: plan,
      meta: { requieresAuth: true }
    },
    {
      path: '/about_database',
      name: 'about_database',
      component: aboutdatabase
    },
    {
      path: '/about_project',
      name: 'about_project',
      component: aboutproject
    },
    /* {
       path: '/video',
       name: 'video',
       component: video
     },*/
    {
      path: '/library',
      name: 'library',
      component: library,
      meta: { requieresAuth: true }

    },
    {
      path: '/help',
      name: 'help',
      component: help,
      meta: { requieresAuth: true }

    },
    {
      path: '/contact',
      name: 'contact',
      component: contact

    },
    {
      path: '/not_authorized',
      name: 'not_authorized',
      component: not_authorized
    },
    {
      path: '/visualisation3d',
      name: 'visualisation3d',
      component: visualisation3d,
      meta: { requieresAuth: true }

    },
    /* {
       path: '*',
       name: 'pagenotfound',
       component: pagenotfound
     },*/



  ]
})

router.beforeEach((to, from, next) => {
  if (to.name == 'not_authorized' && to.params.page == undefined) {
    console.log("going home");
    next({
      name: 'home'
    })
  }
  if (to.meta.requieresAuth) {
    axios
      .get('/api/isauth/')
      .then(response => {
        if (response.data.isauth) {
          next()
        }
        else {
          next({
            name: 'not_authorized',
            params: { page: to.name }
          })

        }
      })
  }
  else {
    next();
  }

})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js